module.exports = __webpack_public_path__ + "img/icon-smtp-config.c50b7a48.svg";